import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import * as lodash from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class TitleService {
    constructor(private title: Title) {}

    setTitle(str: string) {
        this.title.setTitle(lodash.startCase(str));
    }

    setDefaultTitle() {
        this.title.setTitle('HaulierMagic - Transport Management on the Cloud');
    }
}
